import LegalPageLayout from "@/components/feature/LegalPageLayout";
import CompanySections from "./components/CompanySections";
import Seo from "@/components/feature/Seo";
import { seoMeta, organizationFullJsonLd } from "@/lib/seo";

export default function Company() {
  return (
    <>
      <Seo
        title={seoMeta.company.title}
        description={seoMeta.company.description}
        structuredData={[organizationFullJsonLd()]}
      />
      <LegalPageLayout
        kicker="COMPANY PROFILE"
        title="会社概要"
        meta="Strategy × Technology × Human"
      >
        <CompanySections />
      </LegalPageLayout>
    </>
  );
}